"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translate_1 = require("./translate");
exports.getCurrentLocale = translate_1.getCurrentLocale;
exports.setDictionaries = translate_1.setDictionaries;
exports.setLocale = translate_1.setLocale;
exports.translate = translate_1.translate;
var humanize_1 = require("./humanize");
exports.humanize = humanize_1.humanize;
//# sourceMappingURL=index.js.map